import axios from "axios";

const SHAREDDATASET_API_LIST_URL = `${import.meta.env.VITE_API_BASE_URL}/sharedlist`;
const SHAREDDATASET_API_FETCH_URL = `${import.meta.env.VITE_API_BASE_URL}/sharedfetch`;

export const fetchSharedDataFile = async (fileId, idToken) => {
  const getFileContentUrl = `${SHAREDDATASET_API_FETCH_URL}/${fileId}`;
  try {
    const response = await axios.get(getFileContentUrl, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const content = response.data;
    return content;
  } catch (e) {
    console.error("Failed to fetch file content: " + e.message);
    throw e;
  }
};

export const listSharedDataFiles = async (idToken) => {
  try {
    const response = await axios.get(SHAREDDATASET_API_LIST_URL, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = response.data;
    return data.files;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const openSharedDataFile = (fileId, mimeType) => {
  if (mimeType === "text/csv") {
    openCsvFile(fileId);
  } else {
    openGoogleSheet(fileId);
  }
};

const openGoogleSheet = (id) => {
  const url = `https://docs.google.com/spreadsheets/d/${id}`;
  window.open(url, "_blank");
};

const openCsvFile = (id) => {
  const url = `https://drive.google.com/file/d/${id}/`;
  window.open(url, "_blank");
};
